import _ from 'utils/@lodash';
import axios from 'axios';
import EventsEmitter from "events/EventsEmitter";
import { loadConfig, Config } from "config";
import AuthService from "services/AuthService";
import { jwtDecode } from "jwt-decode";
import fileDownload from 'js-file-download';

class JwtService extends EventsEmitter {
	async init() {
		const config: Config = await loadConfig();
		axios.defaults.baseURL = config.api.baseUrl;
		axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
		this.setInterceptors();
		this.handleAuthentication();
	}

	setInterceptors = () => {
		axios.interceptors.response.use(
			response => {
				return response;
			},
			err => {
				return new Promise((resolve, reject) => {
					if (err.response && err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
						// if you ever get an unauthorized response, logout the user
						EventsEmitter.emit('onAutoLogout', 'INVALID_ACCESS_TOKEN');
						this.setSession(null);
					}
					reject(this.handleError(err));
					//throw err;
				});
			}
		);
	};

	handleAuthentication = () => {
		const access_token = this.getAccessToken();

		if (!access_token) {
			EventsEmitter.emit('onNoAccessToken');

			return;
		}

		
		if (this.isAuthTokenValid(access_token)) {
					this.setSession(access_token);
			EventsEmitter.emit('onAutoLogin', true);
		} else {
			this.setSession(null);
			EventsEmitter.emit('onAutoLogout', 'ACCESS_TOKEN_EXPIRED');
		}
	};

	setSession = (access_token: string | null) => {
		
		if (access_token) {
			//localStorage.setItem('jwt_access_token', access_token);
			axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
		} else {
			//localStorage.removeItem('jwt_access_token');
			delete axios.defaults.headers.common.Authorization;
		}
	};

	getAccessToken = () => {
		return AuthService.getToken();// window.localStorage.getItem('jwt_access_token');
	};
	isAuthTokenValid = (access_token: string) => {
		if (!access_token) {
			return false;
		}
		const decoded = jwtDecode(access_token);
		const currentTime = Date.now() / 1000;
		if (decoded?.exp && decoded.exp < currentTime) {
			console.warn('access token expired');
			return false;
		}

		return true;
	};

	handleError = (error: any) => {
		let errorResponse = {
			error: true,
			message: 'UNKNOWN_ERROR',
			details: []
		};

		if (error && error.data && error.data.error) {
			if (typeof error.data.error === 'string') {
				errorResponse.message = error.data.error
			} else {
				errorResponse = { ...error.data.error };
			}
		} else if (error && error.request && error.request.response) {
			error = JSON.parse(error.request.response);
			if (error && error.error) {
				if (typeof error.error === 'string') {
					errorResponse.message = error.error
				} else {
					errorResponse = { ...error.error };
				}
			}
		} else if (error instanceof Error) {
			errorResponse.message = error.message
		} else if (typeof error === 'string') {
			errorResponse.message = error
		} else if (error && error.error) {
			if (typeof error.error === 'string') {
				errorResponse.message = error.error
			} else {
				errorResponse = { ...error.error };
			}
		}

		return errorResponse;
	};

	fetchData = ({ api, method, url, data = null, cancelToken = null }:any) => {
		this.handleAuthentication();
		return new Promise((resolve, reject) => {
			axios({
				method: method,
				url: url,
				data: data,
				cancelToken
			})
			.then(response => {
				if (response.data.success) {
					resolve(response.data);
				} else {
					reject(response.data.error);
				}
			})
			.catch(error => {
				reject( error.response ? error.response.data.error : error );
			});
		});
	};

	fetchRequest = ({ api, method = 'GET', url, data = null, cancelToken = null, headers = null, baseURL = null }: any) => {
		this.handleAuthentication();
		const requestHeaders: any = headers ? headers : (data instanceof FormData ?  {'Content-Type': 'multipart/form-data'} : {});

		return axios({
			method: method,
			url: url,
			baseURL: baseURL || axios.defaults.baseURL,
			data: data,
			cancelToken,
			headers: {
				...axios.defaults.headers,
				...requestHeaders
			}
		});
	};

	handleDownload = ({ url, method, filename, data = null, cancelToken = null }: any) => {
		this.fetchRequest({
			method,
			url,
			data,
			cancelToken,
			headers: {
				...axios.defaults.headers,
				responseType: 'blob',
			}
		})
		.then((res) => {
		  fileDownload(res.data, filename)
		});
	};

	urlToFile = ({ url, method = 'GET', filename, data = null, cancelToken = null }: any, callback: (file: any) => void) => {
		if (!filename) {
			filename = url.split('/').pop().split('#')[0].split('?')[0];
		}
		this.fetchRequest({
			method,
			url,
			data,
			cancelToken,
			headers: {
				...axios.defaults.headers,
				responseType: 'blob',
			}
		})
		.then(res => {
			const contentType = res.headers['content-type'];
			const file = new File([res.data], filename, { type: contentType });
			//console.log(file);
			callback && callback(file);
		})
    }
}

const instance = new JwtService();

instance.init();

export const JwtClass = JwtService;
export default instance;
